export function Parallelogram() {
  return (
    <div className="parallelograms">
      <div className="item"></div>
      <div className="item flip"></div>
    </div>
  );
}
